import { FormFieldTypes } from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { IMultiChoiceFieldOptionsClient } from "@presentation/FormBuilder/components/FormMultipleChoicesField/interface";

export const transformFieldSubmissionValues = (
  fieldType: string,
  fieldSubmissionValues: any,
  DropdownOptions: any
): string | string[] => {
  let fieldSubmissionValue: string | string[];
  switch (FormFieldTypes[fieldType]) {
    case FormFieldTypes.TEXT_INPUT:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.NUMBER_INPUT:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.DROPDOWN:
      let fieldValue =
        fieldSubmissionValues?.optionValue ??
        fieldSubmissionValues?.content ??
        (fieldSubmissionValues && typeof fieldSubmissionValues === "string"
          ? fieldSubmissionValues
          : "-");

      const fieldSubmissionValueType = typeof fieldValue;
      if (fieldSubmissionValueType == "string") {
        for (const obj of DropdownOptions) {
          if (obj.optionKey == fieldValue) {
            fieldValue = {
              value: fieldValue,
              content: obj.optionValue,
            };
          }
        }
      }
      fieldSubmissionValue =
        fieldValue.optionValue ??
        fieldValue.content ??
        fieldValue?.content ??
        fieldValue;
      break;
    case FormFieldTypes.TEXT_AREA:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.LOOKUP:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.DATE_INPUT:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.TIME_PICKER:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.DATE_TIME_PICKER:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.CHECK_BOX:
      fieldSubmissionValue = fieldSubmissionValues?.toString(); //to show boolean as string
      break;
    case FormFieldTypes.RATING:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.MULTIPLE_CHOICES:
      if (fieldSubmissionValues?.length > 0) {
        const multipleSelectedOptions = [];
        fieldSubmissionValues?.map(
          (eachData: IMultiChoiceFieldOptionsClient) => {
            const { optionValue } = eachData;
            multipleSelectedOptions.push(optionValue);
          }
        );
        fieldSubmissionValue = multipleSelectedOptions;
      } else {
        const singleSelectedOptions = [];
        const optionValue =
          fieldSubmissionValues?.optionValue ??
          fieldSubmissionValues?.content ??
          "";
        singleSelectedOptions.push(optionValue);
        fieldSubmissionValue = singleSelectedOptions;
      }
      break;
    case FormFieldTypes.LINEAR_SCALING:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.FILE_UPLOAD:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.CURRENCY:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.PAYMENT:
      fieldSubmissionValue =
        fieldSubmissionValues?.txnAmount ?? fieldSubmissionValues;
      break;
    case FormFieldTypes.BUTTON:
      fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.BANNER:
        fieldSubmissionValue = fieldSubmissionValues;
      break;
    case FormFieldTypes.DOUBLE_PANEL:
        fieldSubmissionValue = fieldSubmissionValues;
      break;
    default:
      break;
  }

  return fieldSubmissionValue;
};

export const isInfographicsVisible = false;
